import Icon from '../components/Icon.vue'

Icon.register({"mars":{"width":384,"height":512,"paths":[{"d":"M372 64H293C282.3 64 277 76.9 284.5 84.5L301.4 101.4 220.7 182.1C198.5 168.1 172.2 160 144 160 64.5 160 0 224.5 0 304S64.5 448 144 448 288 383.5 288 304C288 275.8 279.9 249.5 265.9 227.3L346.6 146.6 363.5 163.5C371.1 171.1 384 165.7 384 155V76C384 69.4 378.6 64 372 64zM144 384C99.9 384 64 348.1 64 304S99.9 224 144 224 224 259.9 224 304 188.1 384 144 384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mars.js
// module id = rpBp
// module chunks = 0